export type UtopiaAccountStats = {
  totalAccounts: number
  microsoftAccounts: number
  nonMicrosoftAccounts: number
  updatedAt?: string
  error?: string
}

export async function fetchUtopiaAccountStats (
  signal?: AbortSignal,
): Promise<UtopiaAccountStats | null> {
  try {
    const res = await fetch('/api/auth/account-stats', {
      signal,
      credentials: 'include',
    })
    const data = await res.json() as UtopiaAccountStats & { error?: string }
    if (!res.ok) {
      return {
        totalAccounts: 0,
        microsoftAccounts: 0,
        nonMicrosoftAccounts: 0,
        error: data.error ?? res.statusText,
        updatedAt: data.updatedAt,
      }
    }
    return data
  } catch (err) {
    if (signal?.aborted) return null
    return {
      totalAccounts: 0,
      microsoftAccounts: 0,
      nonMicrosoftAccounts: 0,
      error: err instanceof Error ? err.message : String(err),
    }
  }
}
